import React from 'react';
import cx from 'classnames';
import isEqual from 'is-equal';
import { toast } from 'react-toastify';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import { 
  Grid, Row, Col, Image, Media, Overlay, Tooltip,
  Form, FormGroup, InputGroup, FormControl, HelpBlock
} from 'react-bootstrap';
import SendButton from 'src/legacy/components/SendButton';
import styles from './smtpConfigurationView.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';
import Toast from 'src/components/toast';
import ProtectedInputField from './components/ProtectedInputField';

class SmtpConfigurationView extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      host: '',
      userName:'',
      password: {},
      useSSL: true,
      useTLS: true,
      port: '',
      errors: {},
      displayName: '',
      fromAddress: ''
    }

    this._handleSaveChangesClicked = this._handleSaveChangesClicked.bind(this);
    this._handleResetClicked = this._handleResetClicked.bind(this);
    this._handlePasswordChange = this._handlePasswordChange.bind(this);
    this._toggleSwitchChange = this._toggleSwitchChange.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedSMTP= localizedStrings.components.integrations.smtp;
    this.localizedCommons = localizedStrings.commons;
    this.localizedIntgerationActions = localizedStrings.components.integrations.actions;

  }

  componentDidMount() {
    this.setState({
      password: '',
      encryption: ''
    })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.errors != nextProps.errors) {
      var errors = this.state.errors;

      if (nextProps.errors) {
        nextProps.errors.forEach(error => {
          errors[error.field] = error.message;
        })
      } else {
        errors = {}
      }

      this.setState({
        errors: errors
      })
    }

    if (!isEqual(nextProps.integration, this.props.integration)) {
      this.setState({
        host: nextProps.integration.configuration.host,
        userName: nextProps.integration.configuration.userName,
        displayName: nextProps.integration.configuration.displayName,
        fromAddress: nextProps.integration.configuration.fromAddress,
        password: {
          value: '',
          current: nextProps.integration.password
        },
        useSSL: nextProps.integration.configuration.useSSL,
        useTLS: nextProps.integration.configuration.useTLS,
        port: nextProps.integration.configuration.port,
      })
    }
  }

  _handleFieldChange(field, e){
    let value = e.target.value;
    this.setState({
      [field]: value,
      errors: {}
    });
  }

  _handlePasswordChange(value){
    this.setState({
      password: {
        ...this.state.password,
        ...value
      }
    });
  }

  _toggleSwitchChange(field, e){

    this.setState({
      [field]: !this.state[field]
    });
  }

  _handleSaveChangesClicked(){
    let errors = this._validateForm();

    this.setState({
      errors: errors
    });

    if(Object.keys(errors).length > 0){      
      return;
    }

    let request = {
      host: this.state.host,
      userName: this.state.userName,
      password: this.state.password.value,
      useSSL: this.state.useSSL,
      useTLS: this.state.useTLS,
      port: this.state.port,
      displayName: this.state.displayName,
      fromAddress: this.state.fromAddress
    }

    this.props.authenticateAccount(request).then(() => {
      if(!this.props.updating && this.props.errors){
        toast(
          <Toast.Failure
            heading = {this.localizedIntegrations.oops_error}
            message = {this.props.errors[0].message}            
          /> , {
            autoClose: 3000,
        })
      }else{
        toast(
          <Toast.Sucess
            heading = {this.localizedCommons.success}
            message = {this.localizedIntegrations.toast.smtp}            
          /> , {
            autoClose: 3000,
        })
        this.props.trackAdoptionMetricsForPluginConnectedEvent('SMTP')
      }
    });
  }

  _handleResetClicked(){
    this.setState({
      host: (this.props.integration && this.props.integration.configuration.host) || '',
      userName: (this.props.integration && this.props.integration.configuration.userName) || '',
      displayName: (this.props.integration && this.props.integration.configuration.displayName) || '',
      fromAddress: (this.props.integration && this.props.integration.configuration.fromAddress) || '',
      password: {
        value: '',
        current: (this.props.integration && this.props.integration.password) || false 
      },
      useSSL: (this.props.integration && this.props.integration.configuration.useSSL ) || true,
      useTLS: (this.props.integration && this.props.integration.configuration.useTLS ) || true,
      port: (this.props.integration && this.props.integration.configuration.port ) || '',
    });
  }

  _validateForm(){
    var errors = {};
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if((!this.state.host || this.state.host.trim() == '')){
      errors['host'] = this.localizedSMTP.error_messages.host;
    }

    if(!this.state.userName || this.state.userName.trim() == ''){
      errors['userName'] = this.localizedSMTP.error_messages.username;
    }

    if (!this.state.displayName || this.state.displayName.trim() == '') {
      errors['displayName'] = this.localizedSMTP.error_messages.display_name;
    }

    if(this.state.fromAddress && this.state.fromAddress.trim() != ''){
      if (!regex.test(this.state.fromAddress)) {
        errors['fromAddress'] = this.localizedSMTP.error_messages.from_address;
      }
    }
    
    if(!this.state.password){
      errors['password'] = this.localizedSMTP.error_messages.password;
    }

    if(this.state.port  == ''){
      errors['port'] = this.localizedSMTP.error_messages.port;
    }

    return errors;
  }

  render(){
    return (
      <div className={styles.content}>
        {this.props.integration && this.props.integration.state.code === "auth_error" &&
          <span className={styles.authMessage}>
            {`${this.localizedIntegrations.integration_expired} ${this.props.integration.type}.`}
          </span>
        }

        {this.props.loading && this._renderLoading()}

        {!this.props.loading && this._renderConfiguration()}

      </div>
    )
  }

  _renderConfiguration() {
    return (
        <Row className={cx(styles.row, styles.form)}>
            <Row className={styles.smptpRow}>
            <Col md={8} className={styles.noPadding}>  
              <FormGroup className={cx(styles.formGroup)}>
                <InputGroup>
                  <div className={styles.start}>
                    <span>{ this.localizedSMTP.activate.host_name }</span>
                  </div>
                  <FormControl
                    type='text'
                    placeholder={ this.localizedSMTP.placeholders.host_name }
                    autoComplete="off"
                    value={this.state.host}
                    onChange={this._handleFieldChange.bind(this, 'host')} />
                </InputGroup>
              </FormGroup>
              {this.state.errors['host'] && <div className={styles.errorMessage}> {this.state.errors['host']}</div>}
            </Col>
            <Col md={4} className={styles.noPadding}>  
              <FormGroup className={cx(styles.formGroup)}>
                <InputGroup>
                  <div className={styles.start}>
                    <span>{ this.localizedSMTP.activate.port }</span>
                  </div>
                  <FormControl
                    type='number'
                    placeholder={ this.localizedSMTP.placeholders.port }
                    autoComplete="off"
                    value={this.state.port}
                    onChange={this._handleFieldChange.bind(this, 'port')} />
                </InputGroup>
              </FormGroup>
            </Col>

            <Col md={6} className={styles.sslOption}>
              <div className={styles.checkbox} onClick={this._toggleSwitchChange.bind(this, 'useSSL')} >
                <i className={cx('fa',this.state.useSSL ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle')} 
                  aria-hidden="true"></i>
                <span>{ this.localizedSMTP.activate.ssl  }</span>
              </div>
            </Col>  
            {!this.state.useSSL && 
              <Col md={6} className={styles.sslOption}>
                <div className={styles.checkbox} onClick={this._toggleSwitchChange.bind(this, 'useTLS')} >
                  <i className={cx('fa',this.state.useTLS ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle')} 
                    aria-hidden="true"></i>
                  <span>{ this.localizedSMTP.activate.starttls  }</span>
                </div>
              </Col>  
            }
            </Row>
          
          <Col md={8} mdOffset={1}> 
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <div className={styles.start}>
                  <span>{ this.localizedSMTP.activate.username  }</span>
                </div>
                <FormControl
                  type='text'
                  placeholder={ this.localizedSMTP.placeholders.username }
                  autoComplete='new-smtp-username'
                  value={this.state.userName}
                  onChange={this._handleFieldChange.bind(this, 'userName')} />
              </InputGroup>
            </FormGroup>
            {this.state.errors['userName'] && <div className = {styles.errorMessage}> {this.state.errors['userName'] }</div> }
          </Col>
          <Col md={8} mdOffset={1}> 
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <div className={styles.start}>
                  <span>{ this.localizedSMTP.activate.password  }</span>
                </div>
                <ProtectedInputField
                  type='password'
                  className={styles.password}
                  autoComplete='new-smtp-password'
                  placeholder={ this.localizedSMTP.placeholders.password }
                  value={this.state.password}
                  onChange={this._handlePasswordChange}
                  actionButton="CHANGE PASSWORD"
                />
              </InputGroup>
            </FormGroup>
            {this.state.errors['password'] && <div className = {styles.errorMessage}> {this.state.errors['password'] }</div> }
          </Col>
        <Col md={8} mdOffset={1}>
          <FormGroup className={cx(styles.formGroup)}>
            <InputGroup>
              <div className={styles.start}>
                <span>{ this.localizedSMTP.activate.from_address  }</span>
              </div>
              <FormControl
                type='text'
                placeholder={ this.localizedSMTP.placeholders.from_address }
                autoComplete="off"
                value={this.state.fromAddress}
                onChange={this._handleFieldChange.bind(this, 'fromAddress')} />
            </InputGroup>
          </FormGroup>
          {this.state.errors['fromAddress'] && <div className={styles.errorMessage}> {this.state.errors['fromAddress']}</div>}
        </Col>
        <Col md={8} mdOffset={1}>
          <FormGroup className={cx(styles.formGroup)}>
            <InputGroup>
              <div className={styles.start}>
                <span>{ this.localizedSMTP.activate.display_name  }</span>
              </div>
              <FormControl
                type='text'
                placeholder={ this.localizedSMTP.placeholders.display_name }
                autoComplete="off"
                value={this.state.displayName}
                onChange={this._handleFieldChange.bind(this, 'displayName')} />
            </InputGroup>
          </FormGroup>
          {this.state.errors['displayName'] && <div className={styles.errorMessage}> {this.state.errors['displayName']}</div>}
        </Col>
        <Col md={12}>
          <div className={styles.buttonTray}>
            <SendButton
              className={cx(styles.save)}
              icon="fa-chevron-right"
              title={this.props.updating ? `${this.localizedCommons.actions.saving}` : this.localizedCommons.actions.save}
              primary
              disabled={this.props.updating}
              onClick={this._handleSaveChangesClicked}
            >
            </SendButton>
            <SendButton
              title={ this.localizedCommons.actions.reset }
              disabled={this.props.updating}
              className={cx(styles.cancel)}
              onClick={this._handleResetClicked}
            >
            </SendButton>
          </div>
        </Col>
      </Row>
    );
  }

  _renderLoading() {
    return (
      <LoadingMessage 
        className={styles.loadingMessage}
        message={ this.localizedSMTP.loading }
        visible={true} />
    )
  }
}

export default SmtpConfigurationView;